var ApplicationSearchService_1;
import { __decorate } from "tslib";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AflaModuleStrategyService } from "../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { OdataQueryService } from "../../../shared/services/odata-query/odata-query.service";
import { ApplicationSearchConstants } from "../application-search/application-search-constants";
import { ODataAction } from "../../../shared/services/odata-query/odata-action.model";
import { ApiApplicationSearchConstants } from "../../../shared/constants/api-constants/api-application-search.constants";
import { ApiModuleConstants } from "../../../shared/constants/api-constants/api-module.constants";
import { UtcDatePipe } from "../../../shared/pipes/utc-date/utc-date.pipe";
import { ApiProxyConstants } from "../../../shared/constants/api-constants/api-proxy.constants";
import { ApiApplicationStatusConstants } from "../../../shared/constants/api-constants/api-application-summary.constants";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { ApiTimeoutConstants } from "../../../shared/constants/api-constants/api-timeout.constants";
import { ApiTownPlanningConstants } from "../../../shared/constants/api-constants/api-town-planning.constants";
import { ApiPropertyValuationprojectCycleConstants } from "../../../shared/constants/api-constants/api-property-valuation-project-cycle.constants";
import { ApiUserConstants } from "../../../shared/constants/api-constants/api-user.constants";
import { ModuleConfig } from "../../../shared/models/module-config.model";
import { SaveSearchService } from "../../../shared/services/save-search/save-search.service";
import { ApiLookupConstants } from "../../../../../../afla-portal-v2/src/app/shared/constants/api-constants/api-lookup.constants";
let ApplicationSearchService = class ApplicationSearchService {
    static { ApplicationSearchService_1 = this; }
    httpClient;
    odataQueryService;
    utcDate;
    saveSearchService;
    optionCheckbox;
    moduleUsers;
    constructor(httpClient, odataQueryService, utcDate, saveSearchService) {
        this.httpClient = httpClient;
        this.odataQueryService = odataQueryService;
        this.utcDate = utcDate;
        this.saveSearchService = saveSearchService;
    }
    static buildSimpleSearchRequest(text, searchColumn, aflaModuleStrategyService, moduleID, useCompleteListForSearch) {
        if ((!text || text === "")) {
            if (searchColumn === SharedConstants.DASHBOARD_FILTERS.LatestApplications || searchColumn === SharedConstants.DASHBOARD_FILTERS.OverdueApplications) {
                return aflaModuleStrategyService.buildApplicationSearchByDays(moduleID, searchColumn);
            }
            return aflaModuleStrategyService.buildApplicationSearchBaseRequest(moduleID, useCompleteListForSearch);
        }
        if (searchColumn !== SharedConstants.SEARCH_BY_DEFAULT) {
            return aflaModuleStrategyService.getApplicationsSearchRequestWithAdditionalFilters(text, searchColumn, moduleID, useCompleteListForSearch);
        }
        return aflaModuleStrategyService.buildApplicationSearchBaseRequest(moduleID, useCompleteListForSearch);
    }
    static buildArraySearchRequest(list, searchColumn, aflaModuleStrategyService, moduleID) {
        // $filter=Name in ('Milk', 'Cheese', 'Donut')
        if (list && list.length > 0) {
            const params = aflaModuleStrategyService.buildListFilter(list, searchColumn);
            return aflaModuleStrategyService.getApplicationsQuery(params);
        }
    }
    static buildGetSingleRequest(aflaModuleStrategyService, jobID) {
        const params = {
            $filter: `jobId eq ${jobID}`
        };
        return aflaModuleStrategyService.getApplicationsQuery(params);
    }
    static getExpandList(aflaModuleStrategyService) {
        return aflaModuleStrategyService.name === ModuleConfig.Cemetery
            || aflaModuleStrategyService.name === ModuleConfig.PropertyAndLease
            || ModuleConfig.PropertyValuation
            ? aflaModuleStrategyService.expandListForApplicationSearchFullList
            : aflaModuleStrategyService.expandListForApplicationSearch;
    }
    // TODO Dylan decouple this from this shared-services,
    //  this shared-services shouldn't know the building logic, make other shared-services for building up odata actions
    searchApplicationsUsingSimpleSearch(text, searchColumn, aflaModuleStrategy, moduleID, withDefaultColumns, useCompleteListForSearch) {
        // this search is Cemetery-specific but follows the CMS simple search pattern
        if (searchColumn.toLowerCase() === ApplicationSearchConstants.BURIAL_ORDER_NUMBER.toLowerCase())
            return this.searchByBurialOrderNo(text, aflaModuleStrategy, moduleID);
        else {
            const simpleQuery = ApplicationSearchService_1.buildSimpleSearchRequest(text, searchColumn, aflaModuleStrategy, moduleID, useCompleteListForSearch);
            return this.switchApplicationSearchList(simpleQuery, aflaModuleStrategy, withDefaultColumns);
        }
    }
    searchApplicationUsingSimpleSearch(text, searchColumn, aflaModuleStrategy, moduleID, withDefaultColumns, useCompleteListForSearch) {
        return this.switchApplicationSearchList(ApplicationSearchService_1.buildSimpleSearchRequest(text, searchColumn, aflaModuleStrategy, moduleID, useCompleteListForSearch), aflaModuleStrategy, withDefaultColumns);
    }
    searchApplicationsByIDList(list, searchColumn, aflaModuleStrategy, moduleID) {
        return this.switchApplicationSearchList(ApplicationSearchService_1.buildArraySearchRequest(list, searchColumn, aflaModuleStrategy, moduleID), aflaModuleStrategy);
    }
    getSingleApplication(aflaModuleStrategyService, jobID) {
        return ApplicationSearchService_1.buildGetSingleRequest(aflaModuleStrategyService, jobID)
            .pipe(map((applicationList) => {
            return applicationList.value.map((application) => {
                return aflaModuleStrategyService.mapFromApplicationEntityToApplicationSearchModel(application);
            })?.pop();
        }));
    }
    searchByEntity(entity, name, surname, organisation, aflaModuleStrategyService, moduleId) {
        // always include moduleID
        // applicantAgent/any(m:m/name eq 'xxxx') and applicantAgent/any(m:m/surname eq 'yyyy')
        // applicantAgent/any(b:contains(tolower(b/name),'xxxx')) and applicantAgent/any(b:contains(tolower(b/surname),'yyyy'))
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (name.trim() !== "")
            filter += ` and ${entity}/any(b:contains(tolower(b/${ApplicationSearchConstants.NAME}), '${name.toLowerCase()}'))`;
        if (surname.trim() !== "")
            filter += ` and ${entity}/any(b:contains(tolower(b/${ApplicationSearchConstants.SURNAME}), '${surname.toLowerCase()}'))`;
        if (organisation.trim() !== "")
            filter += ` and ${entity}/any(b:contains(tolower(b/${ApplicationSearchConstants.ORGANISATION}), '${organisation.toLowerCase()}'))`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    // Cemetery specific
    searchByBurialOrderNo(burialOrderNo, aflaModuleStrategyService, moduleId) {
        // contains(tolower(deceased/burialordernumber), '123')
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (burialOrderNo && burialOrderNo.trim() !== "")
            filter += ` and contains(tolower(${ApplicationSearchConstants.DECEASED}/${ApplicationSearchConstants.BURIAL_ORDER_NUMBER}), '${burialOrderNo.toLowerCase()}')`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    // Cemetery only
    searchByFuneralParlour(parlourName, parlourSurname, parlourOrganisation, aflaModuleStrategyService, moduleId) {
        return this.searchByEntity(ApplicationSearchConstants.FUNERAL_PARLOUR, parlourName, parlourSurname, parlourOrganisation, aflaModuleStrategyService, moduleId);
    }
    // Cemetery only
    searchByFamilyMember(name, surname, aflaModuleStrategyService, moduleId) {
        return this.searchByEntity(ApplicationSearchConstants.FAMILY, name, surname, "", aflaModuleStrategyService, moduleId);
    }
    searchByApplicantAgent(agentName, agentSurname, agentOrganisation, aflaModuleStrategyService, moduleId) {
        return this.searchByEntity(ApplicationSearchConstants.APPLICATION_AGENT, agentName, agentSurname, agentOrganisation, aflaModuleStrategyService, moduleId);
    }
    searchByApplicantInfo(applicantName, applicantSurname, organisation, aflaModuleStrategyService, moduleId) {
        // always include moduleID
        // applicant/any(m:m/name eq 'xxxx') and applicant/any(m:m/surname eq 'yyyy')
        // applicantAgent/any(b:contains(tolower(b/name),'xxxx')) and applicantAgent/any(b:contains(tolower(b/surname),'yyyy'))
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (applicantName.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.APPLICANT}/any(b:contains(tolower(b/${ApplicationSearchConstants.NAME}), '${applicantName.toLowerCase()}'))`;
        if (applicantSurname.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.APPLICANT}/any(b:contains(tolower(b/${ApplicationSearchConstants.SURNAME}), '${applicantSurname.toLowerCase()}'))`;
        if (organisation.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.APPLICANT}/any(b:contains(tolower(b/${ApplicationSearchConstants.ORGANISATION}), '${organisation.toLowerCase()}'))`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    searchByOwnerInfo(name, surname, organisation, aflaModuleStrategyService, moduleId) {
        // always include moduleID
        // properties/any(a:a/owners/any(b:contains(tolower(b/name), 'joh'))) and properties/any(a:a/owners/any(b:contains(tolower(b/surname), 'd')))
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (name.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.PROPERTIES}/any(a:a/${ApplicationSearchConstants.OWNERS}/any(b:contains(tolower(b/${ApplicationSearchConstants.NAME}), '${name.toLowerCase()}')))`;
        if (surname.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.PROPERTIES}/any(a:a/${ApplicationSearchConstants.OWNERS}/any(b:contains(tolower(b/${ApplicationSearchConstants.SURNAME}), '${surname.toLowerCase()}')))`;
        if (organisation.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.PROPERTIES}/any(a:a/${ApplicationSearchConstants.OWNERS}/any(b:contains(tolower(b/${ApplicationSearchConstants.ORGANISATION}), '${organisation.toLowerCase()}')))`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    // PLAMS only
    searchByGroupInfo(name, surname, organisation, groupName, aflaModuleStrategyService, moduleId) {
        // always include moduleID
        // properties/any(a:a/owners/any(b:contains(tolower(b/name), 'joh'))) and properties/any(a:a/owners/any(b:contains(tolower(b/surname), 'd')))
        // owners/any(b:contains(tolower(b/name), 'joh')) and owners/any(b:contains(tolower(b/surname), 'd'))
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (name.trim() !== "")
            filter += ` and ${groupName}/any(b:contains(tolower(b/${ApplicationSearchConstants.NAME}), '${name.toLowerCase()}'))`;
        if (surname.trim() !== "")
            filter += ` and ${groupName}/any(b:contains(tolower(b/${ApplicationSearchConstants.SURNAME}), '${surname.toLowerCase()}'))`;
        if (organisation.trim() !== "")
            filter += ` and ${groupName}/any(b:contains(tolower(b/${ApplicationSearchConstants.ORGANISATION}), '${organisation.toLowerCase()}'))`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    // BPams only
    searchByPropertyInfo(erfNo, farmNo, allotment, sgCode, aflaModuleStrategyService, moduleId) {
        // always include moduleID
        // properties/any(a:a/owners/any(b:contains(tolower(b/name), 'joh'))) and properties/any(a:a/owners/any(b:contains(tolower(b/surname), 'd')))
        // properties/any(b:contains(tolower(b/erfNumber),'xxxx'))
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (erfNo.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.PROPERTIES}/any(b:contains(tolower(b/${ApplicationSearchConstants.ERF_NUMBER}), '${erfNo.toLowerCase()}'))`;
        if (farmNo.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.PROPERTIES}/any(b:contains(tolower(b/${ApplicationSearchConstants.FARM_NUMBER}), '${farmNo.toLowerCase()}'))`;
        if (allotment.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.PROPERTIES}/any(b:contains(tolower(b/${ApplicationSearchConstants.ALLOTMENT}), '${allotment.toLowerCase()}'))`;
        if (sgCode.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.PROPERTIES}/any(b:contains(tolower(b/${ApplicationSearchConstants.SG_CODE}), '${sgCode.toLowerCase()}'))`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    // Cemetery only
    searchByDeceasedDetails(name, surname, idNumber, aflaModuleStrategyService, moduleId, dateOfDeath) {
        // always include moduleID
        // deceased/deceasednames/any(b:contains(tolower(b/name),'fab'))
        // contains(tolower(deceased/idNumber), '9101')
        // deceased/dateOfDeath eq 2021-05-09T00:00:00+02:00
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (name.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.DECEASED}/${ApplicationSearchConstants.DECEASED_NAMES}/any(b:contains(tolower(b/${ApplicationSearchConstants.NAME}), '${name.toLowerCase()}'))`;
        if (surname.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.DECEASED}/${ApplicationSearchConstants.DECEASED_NAMES}/any(b:contains(tolower(b/${ApplicationSearchConstants.SURNAME}), '${surname.toLowerCase()}'))`;
        if (idNumber.trim() !== "")
            filter += ` and contains(tolower(${ApplicationSearchConstants.DECEASED}/${ApplicationSearchConstants.ID_NUMBER}), '${idNumber.toLowerCase()}')`;
        if (dateOfDeath)
            filter += ` and year(${ApplicationSearchConstants.DECEASED}/${ApplicationSearchConstants.DATE_OF_DEATH}) eq ${dateOfDeath.getFullYear()}
      and month(${ApplicationSearchConstants.DECEASED}/${ApplicationSearchConstants.DATE_OF_DEATH}) eq ${dateOfDeath.getMonth()}
      and day(${ApplicationSearchConstants.DECEASED}/${ApplicationSearchConstants.DATE_OF_DEATH}) eq ${dateOfDeath.getDate()}`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    // used by generic "Assigned to" (all users)
    searchByUser(userId, moduleId, aflaModuleStrategyService) {
        // ?moduleId=1&userId=1
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        // optionCheckbox required for Cemeteries
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        /*    // TODO: currently only available for TPAMS - rest to follow later
            if (aflaModuleStrategyService.name === ModuleConfig.TownPlanning) */
        filter += ` and ${AflaModuleStrategyService.showCompleteApplications()}`;
        filter += ` and ${ApplicationSearchConstants.STATUS}/${ApplicationSearchConstants.ASSIGNED_TO} ne null`;
        // filter += ` and createdUserId eq ${userId}`;
        let extendedEndPoint = `${aflaModuleStrategyService.getSearchUrlForModule(ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER)}`
            + `${ApiProxyConstants.QUERY_PREFIX}`;
        extendedEndPoint += `${ApplicationSearchConstants.MODULE_ID}=${moduleId}`;
        extendedEndPoint += `${ApiProxyConstants.PARAMETER_PREFIX}${ApplicationSearchConstants.USER_ID}=${userId}`;
        // required for Cemeteries
        extendedEndPoint += `${ApiProxyConstants.PARAMETER_PREFIX}${ApplicationSearchConstants.WITH_GRAVE}=${this.optionCheckbox}`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQueryExtended(params, extendedEndPoint), aflaModuleStrategyService);
    }
    searchApplicationsCreatedByUser(userId, moduleId, aflaModuleStrategyService) {
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        // optionCheckbox required for Cemeteries
        const filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        let extendedEndPoint = `${aflaModuleStrategyService.getSearchUrlForModule(ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_CREATED_BY_USER)}`
            + `${ApiProxyConstants.QUERY_PREFIX}`;
        extendedEndPoint += `${ApplicationSearchConstants.MODULE_ID}=${moduleId}`;
        extendedEndPoint += `${ApiProxyConstants.PARAMETER_PREFIX}${ApplicationSearchConstants.USER_ID}=${userId}`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQueryExtended(params, extendedEndPoint), aflaModuleStrategyService);
    }
    searchResponsiblePerson(userId, moduleId, aflaModuleStrategyService) {
        // ?moduleId=1&userId=1
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        // optionCheckbox required for Cemeteries
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        /*    // TODO: currently only available for TPAMS - rest to follow later
            if (aflaModuleStrategyService.name === ModuleConfig.TownPlanning) */
        filter += ` and ${AflaModuleStrategyService.showCompleteApplications()}`;
        filter += ` and ${ApplicationSearchConstants.STATUS}/${ApplicationSearchConstants.ASSIGNED_TO} ne null`;
        // filter += ` and createdUserId eq ${userId}`;
        let extendedEndPoint = `${aflaModuleStrategyService.getSearchResponsiblePersonUrlForModule(ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON)}`
            + `${ApiProxyConstants.QUERY_PREFIX}`;
        extendedEndPoint += `${ApplicationSearchConstants.MODULE_ID}=${moduleId}`;
        extendedEndPoint += `${ApiProxyConstants.PARAMETER_PREFIX}${ApplicationSearchConstants.USER_ID}=${userId}`;
        // required for Cemeteries
        extendedEndPoint += `${ApiProxyConstants.PARAMETER_PREFIX}${ApplicationSearchConstants.WITH_GRAVE}=${this.optionCheckbox}`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQueryExtended(params, extendedEndPoint), aflaModuleStrategyService);
    }
    // tolower(status/workflowsection) eq 'unknown'
    searchByUnassignedApplication(moduleId, aflaModuleStrategyService) {
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        filter += ` and ${ApplicationSearchConstants.STATUS}/${ApplicationSearchConstants.ASSIGNED_TO} eq null`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    searchApplicationsWithoutStartDate(moduleId, aflaModuleStrategyService) {
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        // filter += ` and startDate eq null`; // Filter for null startedDate
        filter += ` and ${ApplicationSearchConstants.START_DATE} eq null`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    searchByStatusOrTimeout(moduleId, aflaModuleStrategyService, percent, status, timeoutStatus, daysUntilExpired, category) {
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (percent !== -9999)
            filter += ` and ${ApplicationSearchConstants.STATUS}/${ApplicationSearchConstants.PERCENT_COMPLETE} eq ${percent}`;
        if (status.trim() !== "")
            filter += ` and tolower(${ApplicationSearchConstants.STATUS}/${ApplicationSearchConstants.WORKFLOW_SECTION}) eq '${status.toLowerCase()}'`;
        if (category && category.trim() !== "")
            filter += ` and tolower(${ApplicationSearchConstants.STATUS}/${ApplicationSearchConstants.CATEGORY}) eq '${category.toLowerCase()}'`;
        if (timeoutStatus.trim() !== "")
            filter += ` and tolower(${ApplicationSearchConstants.STATUS}/${ApplicationSearchConstants.TIMEOUT_STATUS}) eq '${timeoutStatus.toLowerCase()}' and eLodgementComplete eq true`;
        if (daysUntilExpired !== -9999)
            filter += ` and ${ApplicationSearchConstants.STATUS}/${ApplicationSearchConstants.DAYS_UNTIL_EXPIRED} eq ${daysUntilExpired}`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    searchByBuildingUse(moduleId, aflaModuleStrategyService, buildingUseName) {
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (buildingUseName && buildingUseName.trim() !== "")
            filter += ` and tolower(${ApplicationSearchConstants.BUILDING_USE}) eq '${buildingUseName.toLowerCase()}' and eLodgementComplete eq true`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    searchByCreatedDate(moduleId, aflaModuleStrategyService, fromDate, toDate) {
        return this.searchByDateRange(moduleId, ApplicationSearchConstants.CREATED_DATE, "", aflaModuleStrategyService, fromDate, toDate);
    }
    // PLAMS only
    searchByDeedTransferDate(moduleId, aflaModuleStrategyService, fromDate, toDate) {
        return this.searchByDateRange(moduleId, ApplicationSearchConstants.DATE_DEED_TRANSFER, "", aflaModuleStrategyService, fromDate, toDate);
    }
    // PLAMS only
    searchByLeaseContractDate(moduleId, aflaModuleStrategyService, fromDate, toDate) {
        return this.searchByDateRange(moduleId, ApplicationSearchConstants.LEASE_START_DATE, ApplicationSearchConstants.LEASE_END_DATE, aflaModuleStrategyService, fromDate, toDate);
    }
    searchByDateRange(moduleId, searchDateColumn, searchDate2Column, aflaModuleStrategyService, fromDate, toDate) {
        // moduleID eq 1 and createdDate ge 2021-03-17T00:00:00.00+02:00
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (searchDate2Column === "") {
            if (fromDate)
                filter += ` and ${searchDateColumn} ge ${this.utcDate.transform(fromDate)}`;
            if (toDate)
                filter += ` and ${searchDateColumn} lt ${this.utcDate.transform(toDate)}`;
            if (fromDate || toDate)
                filter += ` and eLodgementComplete eq true`;
        }
        else {
            // this case is for 2 separate date columns e.g. lease start and end date
            if (fromDate)
                filter += ` and ${searchDateColumn} ge ${this.utcDate.transform(fromDate)}`;
            if (toDate)
                filter += ` and ${searchDate2Column} lt ${this.utcDate.transform(toDate)}`;
            if (fromDate || toDate)
                filter += ` and eLodgementComplete eq true`;
        }
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    sortApplicationList(applications, sortColumn, ascendingSort = true, secondarySortColumn = null) {
        let column;
        let secondaryColumn;
        if (applications.length > 0) {
            // use the first column unless another column has been specified - make sure that the specified column has been included in the list
            // tslint:disable-next-line:forin
            for (const aKey in applications[0]) {
                if (!column) {
                    column = aKey;
                    if (!sortColumn)
                        break;
                }
                if (aKey === sortColumn) {
                    column = aKey;
                    break;
                }
            }
            // tslint:disable-next-line:forin
            for (const aKey in applications[0]) {
                if (!secondaryColumn) {
                    secondaryColumn = aKey;
                    if (!secondarySortColumn)
                        break;
                }
                if (aKey === secondarySortColumn) {
                    secondaryColumn = aKey;
                    break;
                }
            }
            if (ascendingSort) {
                return applications.sort((a, b) => {
                    if (secondaryColumn !== null && a[column] === b[column]) {
                        if (Date.parse(a[secondaryColumn]))
                            return 0 - (a[secondaryColumn] > b[secondaryColumn] ? -1 : 1);
                        if (typeof (a[secondaryColumn]) === "string")
                            return 0 - (a[secondaryColumn].toLowerCase() > b[secondaryColumn].toLowerCase() ? -1 : 1);
                        else if (typeof (a[secondaryColumn]) === "number")
                            return 0 - (a[secondaryColumn] > b[secondaryColumn] ? -1 : 1);
                        else
                            return 0 - (a[secondaryColumn] > b[secondaryColumn] ? -1 : 1);
                    }
                    else {
                        if (Date.parse(a[column]))
                            return 0 - (a[column] > b[column] ? -1 : 1);
                        if (typeof (a[column]) === "string")
                            return 0 - (a[column].toLowerCase() > b[column].toLowerCase() ? -1 : 1);
                        else if (typeof (a[column]) === "number")
                            return 0 - (a[column] > b[column] ? -1 : 1);
                        else
                            return 0 - (a[column] > b[column] ? -1 : 1);
                    }
                });
            }
            else {
                return applications.sort((a, b) => {
                    if (secondaryColumn !== null && a[column] === b[column]) {
                        if (Date.parse(a[secondaryColumn]))
                            return 0 - (a[secondaryColumn] > b[secondaryColumn] ? 1 : -1);
                        if (typeof (a[secondaryColumn]) === "string")
                            return 0 - (a[secondaryColumn].toLowerCase() > b[secondaryColumn].toLowerCase() ? 1 : -1);
                        else if (typeof (a[secondaryColumn]) === "number")
                            return 0 - (a[secondaryColumn] > b[secondaryColumn] ? 1 : -1);
                        else
                            return 0 - (a[secondaryColumn] > b[secondaryColumn] ? 1 : -1);
                    }
                    else {
                        if (Date.parse(a[column]))
                            return 0 - (a[column] > b[column] ? 1 : -1);
                        if (typeof (a[column]) === "string")
                            return 0 - (a[column].toLowerCase() > b[column].toLowerCase() ? 1 : -1);
                        else if (typeof (a[column]) === "number")
                            return 0 - (a[column] > b[column] ? 1 : -1);
                        else
                            return 0 - (a[column] > b[column] ? 1 : -1);
                    }
                });
            }
        }
        else {
            return applications;
        }
    }
    getUsersForModule(moduleId) {
        const params = new HttpParams()
            .append(ODataAction.OrderBy, `${ApplicationSearchConstants.LAST_NAME}, ${ApplicationSearchConstants.FIRST_NAME}`);
        return this.httpClient
            .get(`${ApiModuleConstants.URL}/${moduleId}/${ApiApplicationSearchConstants.FUNCTION_GET_USERS_FOR_MODULE}`, { params });
    }
    getUserName(userId) {
        return this.httpClient
            .get(`${ApiUserConstants.URL}/${userId}`);
    }
    // used to select either distinct status or distinct percent complete values for applications within module
    getStatusForModule(moduleId, statusField) {
        let extendedEndPoint = `${ApiApplicationStatusConstants.URL}${AppRoutingConstants.ROUTE_SEPERATOR}`;
        switch (statusField) {
            case ApplicationSearchConstants.STATUS:
                extendedEndPoint += `${ApiApplicationStatusConstants.FUNCTION_GET_DISTINCT_STATUS}`;
                break;
            case ApplicationSearchConstants.PERCENT_COMPLETE:
                extendedEndPoint += `${ApiApplicationStatusConstants.FUNCTION_GET_DISTINCT_PERCENT}`;
                break;
            case ApplicationSearchConstants.DAYS_UNTIL_EXPIRED:
                break;
            case ApplicationSearchConstants.TIMEOUT_STATUS:
                extendedEndPoint = `${ApiTimeoutConstants.URL}/${ApiTimeoutConstants.FUNCTION_GET_DISTINCT_TIMEOUT_STATUS}`;
                break;
        }
        extendedEndPoint += `${ApiProxyConstants.QUERY_PREFIX}${ApplicationSearchConstants.MODULE_ID}=${moduleId}`;
        return this.httpClient
            .get(`${extendedEndPoint}`);
    }
    // TPAMS specific
    getTownplanners(moduleId) {
        const params = new HttpParams()
            .append(ODataAction.OrderBy, `${ApplicationSearchConstants.SURNAME}, ${ApplicationSearchConstants.NAME}`);
        const extendedEndPoint = `${ApiTownPlanningConstants.URL}${AppRoutingConstants.ROUTE_SEPERATOR}${ApiApplicationSearchConstants.FUNCTION_GET_TOWNPLANNERS}${ApiProxyConstants.QUERY_PREFIX}${ApplicationSearchConstants.MODULE_ID}=${moduleId}`;
        return this.httpClient
            .get(extendedEndPoint, { params });
    }
    // TPAMS specific
    getApplicationTypesForModule(moduleId) {
        const extendedEndPoint = `${ApiTownPlanningConstants.URL}${AppRoutingConstants.ROUTE_SEPERATOR}${ApiTownPlanningConstants.FUNCTION_GET_DISTINCT_APPLICATION_TYPES}${ApiProxyConstants.QUERY_PREFIX}${ApplicationSearchConstants.MODULE_ID}=${moduleId}`;
        return this.httpClient
            .get(extendedEndPoint);
    }
    // TPAMS specific
    searchByTownplanner(townplannerId, moduleId, aflaModuleStrategyService) {
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        filter += ` and ${ApplicationSearchConstants.TOWNPLANNER_ID} eq ${townplannerId}`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    // eVRMS specific
    searchByImplementationDate(moduleId, aflaModuleStrategyService, fromDate, toDate) {
        return this.searchByDateRange(moduleId, ApplicationSearchConstants.DATE_IMPLEMENTATION, "", aflaModuleStrategyService, fromDate, toDate);
    }
    // eVRMS specific
    getValuationRunsForModule(moduleId) {
        const extendedEndPoint = `${ApiPropertyValuationprojectCycleConstants.URL}${AppRoutingConstants.ROUTE_SEPERATOR}${ApiProxyConstants.QUERY_PREFIX}filter=moduleId eq ${moduleId}`;
        return this.httpClient
            .get(extendedEndPoint);
    }
    // eVRMS specific
    searchByValuationRun(runId, moduleId, aflaModuleStrategyService) {
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (runId.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.VALUATION_RUN_ID} eq ${runId}`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    // moduleID eq 1 and applicationTypes/any(b:contains(tolower(b/applicationType),'rezoning'))
    searchByApplicationType(appType, moduleId, aflaModuleStrategyService) {
        const expand = this.odataQueryService.expand(new HttpParams(), ApplicationSearchService_1.getExpandList(aflaModuleStrategyService));
        let filter = AflaModuleStrategyService.buildModuleIDFilter(moduleId, this.optionCheckbox);
        if (appType.trim() !== "")
            filter += ` and ${ApplicationSearchConstants.APPLICATION_TYPES}/any(b:contains(tolower(b/${ApplicationSearchConstants.APPLICATION_TYPE}), '${appType.toLowerCase()}'))`;
        const params = expand.append(ODataAction.Filter, filter);
        return this.switchApplicationSearchList(aflaModuleStrategyService.getApplicationsQuery(params), aflaModuleStrategyService);
    }
    clearCustomApplicationTableColumnMap(aflaModuleStrategy) {
        aflaModuleStrategy.customApplicationTableColumnMap = new Map();
    }
    getCustomApplicationTableColumnMap(aflaModuleStrategy) {
        return aflaModuleStrategy.applicationTableColumnMap;
    }
    setSelectedSearchOption(aflaModuleStrategy, moduleName, searchOption) {
        aflaModuleStrategy.selectedSearchOptionLookup = aflaModuleStrategy.getSearchOptionLookup(searchOption);
        if (searchOption) {
            this.saveSearchService.setSavedSearchOption(moduleName, searchOption);
        }
        // clear column headers
        this.clearCustomApplicationTableColumnMap(aflaModuleStrategy);
    }
    getSearchOptionColumnList(aflaModuleStrategy, searchOptionLookup) {
        const columnList = [];
        aflaModuleStrategy.searchOptionsFieldList.forEach((option) => {
            if (option.searchOption === aflaModuleStrategy.getSearchOptionLookup(searchOptionLookup))
                columnList.push(option);
        });
        return columnList;
    }
    reloadExistingSearch(query, searchOptionLookup, aflaModuleStrategyService) {
        aflaModuleStrategyService.selectedSearchOptionLookup = searchOptionLookup;
        return this.switchApplicationSearchList(query, aflaModuleStrategyService);
    }
    switchApplicationSearchList(query, aflaModuleStrategyService, withDefaultColumns = false) {
        if (!aflaModuleStrategyService.selectedSearchOptionLookup)
            aflaModuleStrategyService.selectedSearchOptionLookup = aflaModuleStrategyService.getSearchOptionLookup(aflaModuleStrategyService.searchOptions[0]);
        if (!withDefaultColumns && aflaModuleStrategyService.searchOptionsWithCustomColumns.indexOf(aflaModuleStrategyService.getSearchOptionLookup(aflaModuleStrategyService.selectedSearchOptionLookup)) > -1) {
            // get column list for first application returned
            const columnList = aflaModuleStrategyService.getCustomApplicationSearchModel(aflaModuleStrategyService.selectedSearchOptionLookup);
            if (columnList.length > 0) {
                return this.getApplicationSearchList(query, columnList, aflaModuleStrategyService, aflaModuleStrategyService.isPrevSavedSearch);
            }
        }
        // reset to default column mapping
        aflaModuleStrategyService.changeAppTableColumnMap(aflaModuleStrategyService.defaultSearchColumns);
        return this.mapApplicationListToApplicationSearchList(query, aflaModuleStrategyService);
    }
    getApplicationSearchList(query, columnList, aflaModuleStrategy, isPrevSavedSearch) {
        return query.pipe(map((applicationList) => {
            let countRows = -1;
            return applicationList.value.map((application) => {
                // for the first row of the search after a previously saved search was displaye3d, we need to refresh the table column map
                countRows++;
                return aflaModuleStrategy.customColumnSearchModel(application, columnList, countRows === 0 && isPrevSavedSearch);
            });
        }));
    }
    mapApplicationListToApplicationSearchList(query, aflaModuleStrategy) {
        return query.pipe(map((applicationList) => {
            return applicationList.value.map((application) => {
                return aflaModuleStrategy.mapFromApplicationEntityToApplicationSearchModel(application);
            });
        }));
    }
    getLookupsObservable(params) {
        return this.httpClient.get(`${ApiLookupConstants.URL}/${ApiLookupConstants.FUNCTION_GET_LOOKUPS_FOR_AFLA_PORTAL}`, { params }).pipe(map(lookups => {
            return lookups;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: OdataQueryService },
        { type: UtcDatePipe },
        { type: SaveSearchService }
    ];
};
ApplicationSearchService = ApplicationSearchService_1 = __decorate([
    Injectable({
        providedIn: "root"
    })
], ApplicationSearchService);
export { ApplicationSearchService };
